'use strict';

var getSummaryLargestLast = function getSummaryLargestLast(numberOfInstalments, totalValue) {
  return getInstalmentsLargestLast(numberOfInstalments, totalValue)[0];
};

var getSummarySmallestLast = function getSummarySmallestLast(numberOfInstalments, totalValue) {
  return getInstalmentsSmallestLast(numberOfInstalments, totalValue)[0];
};

var getInstalmentsLargestLast = function getInstalmentsLargestLast(numberOfInstalments, totalValue) {
  validateArguments(numberOfInstalments, totalValue);
  var instalment = totalValue / numberOfInstalments;
  var instalmentFloored = Math.floor(instalment * 100) / 100;
  var numFullInstalments = numberOfInstalments - 1;
  var finalInstalment = totalValue - instalmentFloored * numFullInstalments;
  var finalInstalmentFixed = parseFloat(finalInstalment.toFixed(2));
  var instalments = [];

  for (var i = 0; i < numFullInstalments; i++) {
    instalments.push(instalmentFloored);
  }

  instalments.push(finalInstalmentFixed);
  return instalments;
};

var getInstalmentsSmallestLast = function getInstalmentsSmallestLast(numberOfInstalments, totalValue) {
  validateArguments(numberOfInstalments, totalValue);
  var centValue = Math.round(totalValue * 100);
  var numInitialInstalments = numberOfInstalments - 1;
  var instalment = Math.ceil(centValue / numberOfInstalments);
  var lastInstalment = centValue - numInitialInstalments * instalment;
  var instalments = [];

  for (var i = 0; i < numInitialInstalments; i++) {
    instalments.push(instalment / 100);
  }

  instalments.push(Math.floor(lastInstalment) / 100);
  return instalments;
};

var validateArguments = function validateArguments(numberOfInstalments, totalValue) {
  if (!totalValue || !numberOfInstalments) {
    throw "Incorrect number of arguments.  This function requires two numeric arguments, numberOfInstalments and totalValue.";
  }

  if (typeof totalValue !== "number" || typeof numberOfInstalments !== "number") {
    throw "Wrong type of argument passed in.  Both totalValue and numberOfInstalments should be numeric values.";
  }
};

var index = {
  getSummaryLargestLast: getSummaryLargestLast,
  getSummarySmallestLast: getSummarySmallestLast,
  getInstalmentsLargestLast: getInstalmentsLargestLast,
  getInstalmentsSmallestLast: getInstalmentsSmallestLast
};

module.exports = index;
